export const ADD_TO_WISH_LIST = "[WISH LIST] ADD TO WISH LIST";
export const GET_WISH_LIST_ITEM_INFO = "[WISH LIST] GET WISH LIST ITEM INFO";
